import { combineReducers } from "@reduxjs/toolkit";
import loginSlicer from "../features/signIn/signIn.slicer";
import ToggleReducer from "./buttonSlice";
import imageUploadSlicer from "../features/imageUpload/imageUpload.slicer";

const rootReducer = combineReducers({
  LoginSlicer: loginSlicer,
  movies: ToggleReducer,
  imageUpload: imageUploadSlicer,
});

export default rootReducer;
